<template>

  <div style="margin-bottom:20px">
    <h3 class="ui dividing header">
      <i class="gift icon"></i>
      <div class="content">
        Akcijas preces
      </div>
    </h3>
    <div class="ui stackable three column grid">
      <div v-for="good in items" class="column">
        <div class="ui fluid card">
          <div>
            <img class="ui small centered image" src="https://res.cloudinary.com/mwsuite/image/upload/f_auto,w_170,h_255,c_lfill/product/1.jpg">
          </div>
          <div class="content">
            <a class="header" style="margin-bottom:5px">Memory Water 18,9l</a>

            <div class="meta">
              <div class="ui tag labels">
                <a class="ui custom_brown label">
                Cena: 10.00 &euro;
              </a>
                <a class="ui green label">
                Drošības nauda: 10.99 &euro;
              </a>
              </div>
            </div>
            <div class="description">
              Strukturēts ūdens 18,9l ar piegādi. Cena par litru tikai ~0,30 EUR. Jo vairāk pudeles vienā reizē pasūta, jo lielāka atlaide tiks automātiski piemērota. Pērkot 2 pud: 5,56 EUR/pud. Drošības nauda 8 EUR/pud.
            </div>
          </div>
          <div class="ui bottom attached button">
            <i class="add icon"></i> Pievienot
          </div>
        </div>
      </div>
    </div>

    <div class="ui container" style="margin-top:20px">
     <button v-on:click="goToTopDiscountGoodsPage" class="ui right floated green button">Apskatīt vairāk <i class="arrow right icon"></i></button>
     <div class="ui clearing hidden divider"></div>
    </div>
  </div>
</template>

<script>


export default {

  data () {
    return {
      items:[{},{},{}]
    }
  },

  methods:{
    goToTopDiscountGoodsPage:function(){
      this.$router.push({name:'discount-goods'});
    }
  }
}
</script>



// WEBPACK FOOTER //
// HomeDiscountedGoods.vue?5a24fa99